import { render, staticRenderFns } from "./ui-radio-group.vue?vue&type=template&id=525a3a22&"
import script from "./ui-radio-group.vue?vue&type=script&lang=ts&"
export * from "./ui-radio-group.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports